<script>
    import {createEventDispatcher} from "svelte"
    import Login from "./Login.svelte";

    const dispatch = createEventDispatcher()
    export let show = true

    const _close = () => {
        show = false
        dispatch("close")
    }

</script>

<div class="main justify-content-center align-items-center" style="display:{show ? "flex" : "none"}">
    <div class="main-content d-flex ">
        <header class="d-flex flex-row justify-content-between">
            <div>Todos los periodos</div>
            <div title={"Cerrar"} class="circular d-flex justify-content-center align-items-center" on:click={() => _close()}>
                <ion-icon name="close-outline"></ion-icon>
            </div>
        </header>
        <section>
            <slot />
        </section>
    </div>
</div>

<style>
    .main {
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: #11111155;
        left: 0;
        top: 0;
        box-shadow: 1px 2px 6px 2px #5a5b5b;
        z-index: 3000;
    }

    header {
        background-color: #f3f3f3;
        padding: 10px;
        color: #673ab755;
        font-weight: bold;
        border-radius: 5px 5px 0px 0px;
        align-items: center;
    }

    .main-content {
        margin: 30px;
        background-color: #fff;
        width: 100%;
        height: calc(100% - 60px);
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        box-shadow: 4px 4px 7px 3px #898989;
    }

    section {
        flex: 1;
        overflow: auto;
    }

    .circular {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        background-color: #2c3e50;
        color: #fff;
        cursor: pointer;
        transition: all 250ms;
        margin-right: 10px;
    }

    .circular:hover {
        transform: scale(1.2);
    }
</style>
